module.exports = __webpack_public_path__ + "img/nest-2.6c8b768d.png";